import axios from 'axios';
import * as Constants from '../utilities/constants/Constants';
import {
  convertFromCamelCase,
  getURLQueryStringAsDictionary
} from '../utilities/HelperFunctions/HelperFunctions';

let apiEndPoint = '';
let storeContentToken = '';

export function setResourcePrefix(value) {
  apiEndPoint = value;
}

export function setStoreContentToken(value) {
  storeContentToken = value;
}

export function getResourcePrefix() {
  return apiEndPoint;
}

const sendRequest = (request, type, requestData, storeId, headerData) => {
  headerData['content-token'] = storeContentToken;
  const requestURL = new URL(request, window.location.origin);
  if (requestURL.origin !== window.location.origin) {
    // if (requestURL.host !== 'designer.localhost:3000') {
    return sendRequestViaProxy(request, type, requestData, storeId, headerData);
  }

  switch (type) {
    case Constants.REQUEST_TYPE_GET:
      return axios.get(request, {
        headers: headerData
      });
    case Constants.REQUEST_TYPE_POST:
      return axios.post(request, requestData, {
        headers: headerData
      });
    case Constants.REQUEST_TYPE_PUT:
      return axios.put(request, requestData, {
        headers: headerData
      });
    case Constants.REQUEST_TYPE_DELETE:
      return axios.delete(request, {
        headers: headerData
      });

    default:
      return '';
  }
};

const sendRequestViaProxy = (request, type, data, storeId, headerData) => {
  const requestData = JSON.stringify({
    service_url: request,
    store_id: storeId
  });

  headerData['content-type'] = 'application/x-www-form-urlencoded';
  const postData = `request=${escape(requestData)}`;

  const url = `${window.location.origin}/api/platform_proxy`;
  // let url = 'http://localhost:3000' + '/api/platform_proxy';
  return axios.post(url, postData, { headers: headerData });
};

export function setSession() {
  const eCommerceSiteInternalName = window.location.pathname.split('/')[1];
  let skuFromURL = '';
  let gskuFromURL = '';
  const queryDict = getURLQueryStringAsDictionary();
  gskuFromURL = queryDict.get('gsku');
  skuFromURL = queryDict.get('sku');
  let skuField = '';
  if (gskuFromURL) {
    skuField = `&gsku=${gskuFromURL}`;
  }
  if (skuFromURL) {
    skuField += `&sku=${skuFromURL}`;
  }

  return sendRequest(
    `${apiEndPoint}/react/launch_designer?url_identifier=${eCommerceSiteInternalName}${skuField}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getEnvVariables(identifier, gsku, sku) {
  let skuField = '';
  if (gsku) {
    skuField = `&gsku=${gsku}`;
  }
  if (sku) {
    skuField += `&sku=${sku}`;
  }

  return sendRequest(
    `${apiEndPoint}/environmental_variables?url_identifier=${identifier}${skuField}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getStoreDetails(
  storeToken,
  gsku,
  sku,
  identifier,
  shouldSkipProduct
) {
  let skuField = '';
  let skipProductField = '';
  if (gsku) {
    skuField = `&gsku=${gsku}`;
  }
  if (sku) {
    skuField += `&sku=${sku}`;
  }
  if (shouldSkipProduct) {
    skipProductField = '&skip_products=true';
  }
  return sendRequest(
    `${apiEndPoint}/stores/${storeToken}?url_identifier=${identifier}${skuField}${skipProductField}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export const getProductDetailsInStore = (
  storeId,
  cacheTimestamp,
  storeCacheTimestamp,
  accountId
) =>
  sendRequest(
    `${apiEndPoint}/application_groups/LPTS?store_id=${storeId}&group_cache_timestamp=${cacheTimestamp}&store_cache_timestamp=${storeCacheTimestamp}&account_id=${accountId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );

export function prepareRequestParams(paramsDict) {
  let result = '?';
  const allKeys = Object.keys(paramsDict);
  allKeys.forEach(key => {
    result += `${key}=${paramsDict[key]}&`;
  });
  return result;
}

export function fetchThemes(dict, cacheTimestamp, storeId) {
  const paramsRequest = prepareRequestParams(dict);
  const request = `${apiEndPoint}/themes${paramsRequest}cache_timestamp=${cacheTimestamp}`;
  return sendRequest(request, Constants.REQUEST_TYPE_GET, null, storeId, {});
}

export function getThemeElements(themeId, type, storeId, dict, cacheTimestamp) {
  const typeInRequestFormat = `${convertFromCamelCase(type)}s`;
  const paramsRequest = prepareRequestParams(dict);
  const request = `${apiEndPoint}/themes/${themeId}/${typeInRequestFormat}${paramsRequest}cache_timestamp=${cacheTimestamp}`;
  return sendRequest(request, Constants.REQUEST_TYPE_GET, null, storeId, {});
}

export function getStartupThemeDetails() {
  return sendRequest(
    `${apiEndPoint}/content/startup_theme`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getStartupSceneDetails(themeId) {
  return sendRequest(
    `${apiEndPoint}/content/themes/${themeId}/scenes`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getPatternDesignContents(id) {
  if (id) {
    return sendRequest(
      `${apiEndPoint}/pattern_design_api/categories?includeSubcategories=false&topLevelCategoryId=${id}`,
      Constants.REQUEST_TYPE_GET,
      null,
      null,
      {}
    );
  }
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/categories?includeSubcategories=false`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getPatternInfo(id) {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/designer_info?search_parameters[designerId]=${id}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getFololiaPurchaseDetails(id) {
  return sendRequest(
    `${apiEndPoint}/fotolia_media_data?id=${id}&thumbnail_size=400`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}
export function getPatternDesignCost(id) {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/media_cost?store_id=${id}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getUnsplashContents(text, pageNumber) {
  let unsplashURL = apiEndPoint;
  if (text !== 'null') {
    unsplashURL += `/unsplash_images/search?query=${text}&per_page=30&page=${pageNumber}`;
  } else {
    unsplashURL += `/unsplash_images?per_page=30&page=${pageNumber}`;
  }
  return sendRequest(unsplashURL, Constants.REQUEST_TYPE_GET, null, null, {});
}

export function getVecteezyContents(text, pageNumber) {
  let vecteezyURL = apiEndPoint;
  if (text !== 'null') {
    vecteezyURL += `/vecteezy_images/search?q=${text}&shape_type=icons&page=${pageNumber}`;
  } else {
    vecteezyURL += `/vecteezy_images/search?page=${pageNumber}`;
  }
  return sendRequest(vecteezyURL, Constants.REQUEST_TYPE_GET, null, null, {});
}

export function getGettyImageContents(type, text, pageNumber, storeId) {
  let gettyImageURL = apiEndPoint;
  if (text !== 'null') {
    gettyImageURL += `/getty_images_api/search?type=${type}&phrase=${text}&page=${pageNumber}&store_id=${storeId}`;
  } else {
    gettyImageURL += `/getty_images_api/search?type=${type}&phrase=&page=${pageNumber}&store_id=${storeId}`;
  }
  return sendRequest(gettyImageURL, Constants.REQUEST_TYPE_GET, null, null, {});
}

export function getIStockContents(type, text, pageNumber, storeId) {
  let iStockURL = apiEndPoint;
  if (text !== 'null') {
    iStockURL += `/istock_api/search?type=${type}&phrase=${text}&page=${pageNumber}&store_id=${storeId}`;
  } else {
    iStockURL += `/istock_api/search?type=${type}&phrase=&page=${pageNumber}&store_id=${storeId}`;
  }
  return sendRequest(iStockURL, Constants.REQUEST_TYPE_GET, null, null, {});
}

export function searchForPatterns(categoryId, colorInHex, text, offset) {
  let searchURL = `${apiEndPoint}/pattern_design_api/search?search_parameters[limit]=30`;
  if (categoryId != null) {
    searchURL += `&search_parameters[categoryIds]=${categoryId}`;
  }
  if (colorInHex != null) {
    searchURL += `&search_parameters[colors]=${colorInHex}`;
  }
  if (text !== 'null') {
    searchURL += `&search_parameters[text]=${text}`;
  }
  searchURL += `&search_parameters[offset]=${offset}`;
  return sendRequest(searchURL, Constants.REQUEST_TYPE_GET, null, null, {});
}

export function getDefaultColors(storeId, cacheTimestamp) {
  return sendRequest(
    `${apiEndPoint}/stores/${storeId}/textcolors?cache_timestamp=${cacheTimestamp}`,
    Constants.REQUEST_TYPE_GET,
    null,
    storeId,
    {}
  );
}

export function getFontDetails(storeId, cacheTimestamp) {
  return sendRequest(
    `${apiEndPoint}/stores/${storeId}/fonts?cache_timestamp=${cacheTimestamp}`,
    Constants.REQUEST_TYPE_GET,
    null,
    storeId,
    {}
  );
}

export function sendMultipleAddText(data) {
  return sendRequest(
    `${apiEndPoint}/content/multi_texts`,
    Constants.REQUEST_TYPE_PUT,
    data,
    null,
    {}
  );
}

export function sendAddText(data) {
  return sendRequest(
    `${apiEndPoint}/content/texts`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {}
  );
}

export function sendUpdateText(textId, data) {
  return sendRequest(
    `${apiEndPoint}/content/texts/${textId}`,
    Constants.REQUEST_TYPE_PUT,
    data,
    null,
    {}
  );
}
export function inspirationCreate(token) {
  return sendRequest(
    `${apiEndPoint}/projects/${token}/ajax_check_for_inspiration_project_creation_completion`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function sendUploadFile(data, config) {
  config.headers = { 'content-token': storeContentToken };
  return axios.post(`${apiEndPoint}/content/user_photos`, data, config);
}

export function updateUserPhoto(userPhotoId, data) {
  return sendRequest(
    `${apiEndPoint}/content/user_photos/${userPhotoId}`,
    Constants.REQUEST_TYPE_PUT,
    data,
    null,
    {}
  );
}

export function uploadInvoiceData(projectId, shippingId, invoiceData) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectId}/shippings/${shippingId}`,
    Constants.REQUEST_TYPE_PUT,
    invoiceData,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function getShippingDetails(projectToken) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectToken}/shipping_detail?parent=true`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getUploadedFile(id, storeId) {
  return sendRequest(
    `${apiEndPoint}/content/user_photos/${id}/ajax_check_for_upload_completion?store_id=${storeId}&source_store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function checkSuperResolutionStatus(userPhotoId, storeId) {
  const eCommerceSiteInternalName = window.location.pathname.split('/')[1];
  return sendRequest(
    `${apiEndPoint}/content/user_photos/${userPhotoId}/ajax_check_for_super_resolution?e_commerce_site_internal_name=${eCommerceSiteInternalName}&store_id=${storeId}&source_store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getDropboxUploadedFile(id, storeId) {
  return sendRequest(
    `${apiEndPoint}/content/user_photos/${id}/ajax_check_for_upload_completion?store_id=${storeId}&source_store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getInstagramUploadedFile(userPhotoId, storeId) {
  return sendRequest(
    `${apiEndPoint}/content/user_photos/ajax_check_for_upload_completions?user_photo_ids=${userPhotoId}&store_id=${storeId}&source_store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function importDropboxContent(data) {
  return sendRequest(
    `${apiEndPoint}/content/user_photos/import_from_dropbox`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function importInstagramContent(data) {
  return sendRequest(
    `${apiEndPoint}/content/user_photos/import_from_instagram`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function saveProject(saveData) {
  return sendRequest(
    `${apiEndPoint}/projects`,
    Constants.REQUEST_TYPE_POST,
    saveData,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function updateProject(saveData, projectToken) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectToken}`,
    Constants.REQUEST_TYPE_PUT,
    saveData,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function sendSubmitForm(requestDataJSON, projectId) {
  const myForm = document.createElement('form');
  document.body.appendChild(myForm);
  myForm.method = 'post';
  myForm.action = `${apiEndPoint}/projects/${projectId}/platform_print`;

  const element = document.createElement('input');
  element.type = 'hidden';
  element.name = 'request';
  element.value = requestDataJSON;
  myForm.appendChild(element);
  myForm.submit();
}

export function sendOrderPrintForm(requestDataJSON, groupId) {
  const myForm = document.createElement('form');
  document.body.appendChild(myForm);
  myForm.method = 'post';
  myForm.action = `${apiEndPoint}/content/project_groups/${groupId}/order_print`;

  const element = document.createElement('input');
  element.type = 'hidden';
  element.name = 'request';
  element.value = requestDataJSON;
  myForm.appendChild(element);
  myForm.submit();
}

export function sendSubmitShippingDetails(requestDataJSON, projectId) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectId}/shippings`,
    Constants.REQUEST_TYPE_POST,
    requestDataJSON,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function getInspirationFilters() {
  const inspirationFilterURL = `${apiEndPoint}/inspiration_filters`;
  return sendRequest(
    inspirationFilterURL,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getInspirations(
  offset,
  perPage,
  category,
  language,
  preference,
  storeToken
) {
  let inspirationURL = `/projects/inspirations?offset=${offset}&per_page=${perPage}&lang=${language}`;
  if (preference) {
    inspirationURL += `&template_preference=${preference}&store_token=${storeToken}`;
  }
  if (category) {
    inspirationURL += `&q=${category}`;
  }

  return sendRequest(
    inspirationURL,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function fetchPlaceableDetails(
  themeId,
  placeableType,
  placeableId,
  storeId,
  isInspirationUserPhoto,
  cacheTimestamp
) {
  const requestUrl = `${apiEndPoint}/themes/${themeId}/${placeableType.toLowerCase()}s/${placeableId}?store_id=${storeId}&is_inspiration=${isInspirationUserPhoto}&cache_timestamp=${cacheTimestamp}`;
  return sendRequest(requestUrl, Constants.REQUEST_TYPE_GET, null, storeId, {});
}

export function fetchUserPhotoDetails(
  placeableType,
  idListString,
  storeId,
  sourceStoreId,
  isInspirationUserPhoto,
  cacheTimestamp
) {
  const requestUrl = `${apiEndPoint}/${placeableType.toLowerCase()}s/list?store_id=${storeId}&source_store_id=${sourceStoreId}&is_inspiration=${isInspirationUserPhoto}&cache_timestamp=${cacheTimestamp}&ids=${idListString}`;
  return sendRequest(requestUrl, Constants.REQUEST_TYPE_GET, null, storeId, {});
}

export function fetchProjectDetails(projectToken) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectToken}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getProjectReviewedStatus(projectToken) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectToken}/reviewed`,
    Constants.REQUEST_TYPE_PUT,
    null,
    null,
    {}
  );
}

export function fetchProjectDetailsFromExternalId(projectId, storeId) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectId}?find_by_external_id=true&store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function shareSamplePrintableSample(id, data) {
  return sendRequest(
    `${apiEndPoint}/projects/${id}/share_sample_printable_bits`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function platformEmailSample(externalId, data) {
  return sendRequest(
    `${apiEndPoint}/projects/${externalId}/platform_email_sample_printable_bits`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function shareSampleViaEmailForWallartLite(id, data) {
  return sendRequest(
    `${apiEndPoint}/projects/${id}/platform_share`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function shareSampleViaEmail(externalId, data) {
  return sendRequest(
    `${apiEndPoint}/projects/${externalId}/platform_email_message`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function getECommerceServicesUrl(eCommerceServicesUrl, id) {
  const url = `${eCommerceServicesUrl}/projects?path_info=/projects`;
  return sendRequest(url, Constants.REQUEST_TYPE_GET, null, id, {});
}

export function getUserInfo(eCommerceServicesUrl, id) {
  const url = `${eCommerceServicesUrl}/user_info?path_info=/user_info`;
  return sendRequest(url, Constants.REQUEST_TYPE_GET, null, id, {});
}

export function saveForWebLink(data) {
  return sendRequest(
    `${apiEndPoint}/api/platform_save`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {}
  );
}

export function sendPatterDesignLoginCredentials(loginId, password, storeId) {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/login?username=${loginId}&password=${password}&store_id=${storeId}&is_vanilla=true`,
    Constants.REQUEST_TYPE_POST,
    null,
    null,
    {}
  );
}

export function sendVecteezyLoginCredentials(loginId, password, storeId) {
  return sendRequest(
    `${apiEndPoint}/vecteezy_login_user?login=${loginId}&password=${password}&store_id=${storeId}&is_vanilla=true`,
    Constants.REQUEST_TYPE_POST,
    null,
    null,
    {}
  );
}

export function sendDreamstimeLoginCredentials(data) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/login`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function sendVecteezyLogoutRequest(storeId) {
  return sendRequest(
    `${apiEndPoint}/vecteezy_log_out?store_id=${storeId}&is_vanilla=true`,
    Constants.REQUEST_TYPE_DELETE,
    null,
    null,
    {}
  );
}

export function sendPatterDesignLogoutRequest(storeId) {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/logout?store_id=${storeId}&is_vanilla=true`,
    Constants.REQUEST_TYPE_DELETE,
    null,
    null,
    {}
  );
}

export function sendDreamstimeLogoutRequest() {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/logout`,
    Constants.REQUEST_TYPE_DELETE,
    null,
    null,
    {}
  );
}

export function sendProjectDetails(data, id) {
  return sendRequest(
    `${apiEndPoint}/projects/${id}/platform_print`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function getVecteezyRecolorList(id, svgUrl) {
  return sendRequest(
    `${apiEndPoint}/vecteezy_images/${id}/get_colors?svg_url=${svgUrl}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getPatternDesignRecolorList(id) {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/get_colors?search_parameters[id]=${id}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function createUserPhoto(type, id, storeId, referenceId) {
  return sendRequest(
    `${apiEndPoint}/designer/create_user_photo?type=${type}&id=${id}&store_id=${storeId}&svg_reference_id=${referenceId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function createUserPhotoForHostedContent(
  type,
  id,
  storeId,
  imageSource
) {
  return sendRequest(
    `${apiEndPoint}/designer/create_user_photo?user_photo_type=${type}&image_source=${imageSource}&media_id=${id}&store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getPrintConfirmation(token, RIPName) {
  return sendRequest(
    `${apiEndPoint}/projects/${token}/printable_image_info?rip_type=${RIPName}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function postPerformWithData(data, url) {
  const myForm = document.createElement('form');
  document.body.appendChild(myForm);
  myForm.method = 'post';
  myForm.action = url;

  const element = document.createElement('input');
  element.type = 'hidden';
  element.name = 'request';
  element.value = data;
  myForm.appendChild(element);
  myForm.submit();
}

export function getCountryList() {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/countries`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function registerAccount(params) {
  return sendRequest(
    `${apiEndPoint}/pattern_design_api/sign_up_user`,
    Constants.REQUEST_TYPE_POST,
    params,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function getPrinterModalList() {
  return sendRequest(
    `${apiEndPoint}/printer_model_list`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getListOfUserType() {
  return sendRequest(
    `${apiEndPoint}/user_type`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function addPrinter(data, storeId) {
  return sendRequest(
    `${apiEndPoint}/lite_partner/${storeId}/update_printer_serial_number`,
    Constants.REQUEST_TYPE_PUT,
    data,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function getTextFontsInsp(ids) {
  return sendRequest(
    `${apiEndPoint}/content/fonts/family_info?font_ids=${ids}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function fetchInstagramContents(nextURL) {
  let request = `${apiEndPoint}/instagram/get_media`;
  if (nextURL) {
    request = `${request}?next=${nextURL}`;
  }
  return sendRequest(request, Constants.REQUEST_TYPE_GET, null, null, {});
}

export function getEditorsChoiceImages(type, pageIndex, pageSize) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/search?type=${type}&filter=popular&page=${pageIndex}&page_size=${pageSize}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function searchDreamstimeContents(keyword, type, pageIndex, count) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/search?keywords=${keyword}&type=${type}&page=${pageIndex}&page_size=${count}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getDreamstimeInfo(id, storeId) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/${id}/content_detail?store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getContentDetailForDreamstime(mediaId, storeId) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/${mediaId}/content_detail?store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getContentDetailListForDreamstime(imageIds) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/collection_image_details?image_ids=${imageIds}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getDreamstimeAccountUserInfo() {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/account_info`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function registerDreamstiemAccount(data) {
  return sendRequest(
    `${apiEndPoint}/dreamstime_api/register_account`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function authenticateContentFolder(data, themeId) {
  return sendRequest(
    `${apiEndPoint}/content/themes/${themeId}/authenticate`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/json'
    }
  );
}

export function getLocationDetails() {
  return sendRequest(
    `${apiEndPoint}/shippings/location_data`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getCountryNameList() {
  return sendRequest(
    `${apiEndPoint}/shippings/countries`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getStateNameList(countryCode) {
  return sendRequest(
    `${apiEndPoint}/shippings/states?country_code=${countryCode}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function searchForAdobeStockContents(
  language,
  contentFilter,
  text,
  offset,
  orderFilter
) {
  return sendRequest(
    `${apiEndPoint}/adobe_stock_api/search?locale=${language}&content_filter=${contentFilter}&word=${text}&page=${offset}&order_filter=${orderFilter}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getAdobeStockAccountUserInfo() {
  return sendRequest(
    `${apiEndPoint}/adobe_stock_api/user_data`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function adobeStockLogoutRequest() {
  return sendRequest(
    `${apiEndPoint}/adobe_stock_api/remove_adobe_stock_credentials`,
    Constants.REQUEST_TYPE_DELETE,
    null,
    null,
    {}
  );
}

export function searchForHPMosaicContents(pageIndex) {
  return sendRequest(
    `${apiEndPoint}/hosted_content/search?page=${pageIndex}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function randomizeHPMosaicContents(pageIndex) {
  return sendRequest(
    `${apiEndPoint}/hosted_content/randomize?page=${pageIndex}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function getHPMosaicMediaData(id) {
  return sendRequest(
    `${apiEndPoint}/hosted_content/${id}/info`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function sendFeedbackDetails(data) {
  return sendRequest(
    `${apiEndPoint}/api/feedback_details`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function pollForPublishRequest(contentType, contentId) {
  return sendRequest(
    `${apiEndPoint}/blockchain/transactions/ajax_check_for_transaction_completion?content_type=${contentType}&content_id=${contentId}&transaction_action=Publish`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function publishRequestForBlockChain(storeId, data) {
  return sendRequest(
    `${apiEndPoint}/blockchain/transactions/publish?store_id=${storeId}`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {}
  );
}

export function pollForCreateRequest(projectGroupId) {
  return sendRequest(
    `${apiEndPoint}/blockchain/transactions/ajax_check_for_transaction_completion?project_group_id=${projectGroupId}&transaction_action=Create`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function blockChainCreateRequest(storeId, data) {
  return sendRequest(
    `${apiEndPoint}/blockchain/transactions/create?store_id=${storeId}`,
    Constants.REQUEST_TYPE_POST,
    data,
    null,
    {}
  );
}

export function sendStartDesignDetail(projectToken) {
  return sendRequest(
    `${apiEndPoint}/projects/${projectToken}/start_design`,
    Constants.REQUEST_TYPE_PUT,
    null,
    null,
    {}
  );
}

export function getHostedContents(themeId) {
  return sendRequest(
    `${apiEndPoint}/hosted_content_themes/${themeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function validateRetailerPosCode(posCode, storeId) {
  return sendRequest(
    `${apiEndPoint}/projects/validate_retailer_pos_code?pos_code=${posCode}&store_id=${storeId}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function fetchProjects(projectGroupId, storeId, cacheTimestamp) {
  return sendRequest(
    `${apiEndPoint}/content/project_groups/${projectGroupId}?store_id=${storeId}&cache_timestamp=${cacheTimestamp}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function deleteProject(projectGroupId, projectId) {
  return sendRequest(
    `${apiEndPoint}/content/project_groups/${projectGroupId}/remove_project/${projectId}`,
    Constants.REQUEST_TYPE_POST,
    null,
    null,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function getWallLayouts(cacheTimestamp) {
  return sendRequest(
    `${apiEndPoint}/wall_layouts?cache_timestamp=${cacheTimestamp}&version=2.0`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function fetchWallLayout(layoutId, storeId, cacheTimestamp) {
  return sendRequest(
    `${apiEndPoint}/wall_layouts/${layoutId}?store_id=${storeId}&cache_timestamp=${cacheTimestamp}`,
    Constants.REQUEST_TYPE_GET,
    null,
    null,
    {}
  );
}

export function generateAiImage(storeId, prompt) {
  const eCommerceSiteInternalName = window.location.pathname.split('/')[1];
  const config = { headers: { 'content-token': storeContentToken } };
  return sendRequest(
    `${apiEndPoint}/content/user_photos/generate_openai_image?e_commerce_site_internal_name=${eCommerceSiteInternalName}&store_id=${storeId}&prompt=${prompt}`,
    Constants.REQUEST_TYPE_POST,
    {},
    config,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function importFromAI(payload) {
  const config = { headers: { 'content-token': storeContentToken } };
  return sendRequest(
    `${apiEndPoint}/content/user_photos/import_from_openai`,
    Constants.REQUEST_TYPE_POST,
    payload,
    config,
    {
      'content-type': 'application/x-www-form-urlencoded'
    }
  );
}

export function applySuperResolution(userPhotoId, storeId) {
  const eCommerceSiteInternalName = window.location.pathname.split('/')[1];
  return sendRequest(
    `${apiEndPoint}/content/user_photos/apply_super_resolution?user_photo_id=${userPhotoId}?e_commerce_site_internal_name=${eCommerceSiteInternalName}&store_id=${storeId}&source_store_id=${storeId}`,
    Constants.REQUEST_TYPE_PUT,
    {},
    null,
    {}
  );
}
